import { HttpErrorResponse, HttpHeaders, HttpInterceptorFn } from '@angular/common/http';
import { LstorageService } from '../services/common/lstorage.service';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, throwError } from 'rxjs';
import { ROUTE_CONFIGS } from '../configs/routerConfig';
import { LSkeys } from '../configs/app.constants';

export const authenticationInterceptor: HttpInterceptorFn = (req, next) => {
  let lsServ = inject(LstorageService)
  let router = inject(Router)
  let headers = new HttpHeaders().set('access_token', `${inject(LstorageService).getItem(LSkeys.AUTH_TOKEN) || inject(LstorageService).getItem(LSkeys.OTP_TOKEN)}`).set('language_id', inject(LstorageService).getItem(LSkeys.LANGUAGE_ID) || '')
  req = req.clone({
    headers: headers
  })
  return next(req).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.status === 401) {
        const errorBody = error.error;
        if (errorBody.success === -3 && errorBody.msg.includes('token has expired')) {
          lsServ.clear();
          router.navigateByUrl(ROUTE_CONFIGS.LOGIN_ROUTE);
        } else if (errorBody.UnAuthorizedRequest && router.url.startsWith('/customer')) {
          lsServ.clear();
          router.navigateByUrl(ROUTE_CONFIGS.LOGIN_ROUTE);
        }
      }
      return throwError(() => error);
    })
  );
};
